<template>
  <div></div>
</template>
<script>
import AdminService from "../services/admin.service";
import AlertService from "../services/alert.service";
import Vue from "vue";
import moment from "moment";
Vue.prototype.moment = moment;

export default {
  name: "FilterMixins",
  mixins: [],
  components: {  },
  data() {
    return {
        originalList: [],
        filteredList: [],
        isDataFiltering: false,    
        executeReset: false,
        filterByCreatedDate: false,
        filterByCreatedStartDate: new Date(2020, 0, 1),
        filterByCreatedEndDate: new Date(),    
        filterByCompletedDate: false,
        filterByCompletedStartDate: new Date(2020, 0, 1),
        filterByCompletedEndDate: new Date(),    
        filterByStatusValue: "",    
    };
  },
  props: {
    baseUrl: {
      type: String,
      default: AdminService.getBaseUrl()
    }
  },
  created() {
  },
  methods: {
    setFilterByStatusValue: function(value){
      //console.log("setFilterByStatusValue: " + value)
      this.filterByStatusValue = value;
    },
    setFilterByStartDateValue: function(value, type){
//      console.log("setFilterByStartDateValue: " + value)
      if (type == "completed"){
        this.filterByCompletedDate = true;
        this.filterByCompletedStartDate = value;
      } else {
        this.filterByCreatedDate = true;
        this.filterByCreatedStartDate = value;
      }
    },
    setFilterByEndDateValue: function(value, type){
//      console.log("setFilterByEndDateValue: " + value)
      if (type == "completed"){
        this.filterByCompletedDate = true;
        this.filterByCompletedEndDate = value;
      } else {
        this.filterByCreatedDate = true;
        this.filterByCreatedEndDate = value;
      }
    },
    preReset: async function(){
      this.isDataFiltering = false;
      this.executeReset = true;
      //console.log("preReset");
      AdminService.displayInfoMessage({text: "Resetting table data. Please wait..."});
      this.filterByStatusValue = "";
      this.filterByCreatedStartDate = new Date(2020, 0, 1);
      this.filterByCreatedEndDate = new Date();  
      this.filterByCompletedStartDate = new Date(2020, 0, 1);
      this.filterByCompletedEndDate = new Date();  
      this.filterByCreatedDate = false;
      this.filterByCompletedDate = false;
    },
    postReset: function(){
      //console.log("postReset");
      AlertService.closeAlert();
      this.executeReset = false;
    },
    preFilter: async function(){
      //console.log("beforeFilter");
      this.isDataFiltering = true;
      AdminService.displayInfoMessage({text: "Filtering table data. Please wait..."});
      this.filteredList =  [...this.originalList];
      //console.log("this.filteredList.length : " + this.filteredList.length);
    },
    postFilter: async function(){
      //console.log("postFilter");
      this.isDataFiltering = false;
      AlertService.closeAlert();
    },
    async filterByClientId(clientId){
      //console.log("filterByClientId: " + clientId + "   original size: " + this.filteredList.length);
      this.filteredList = this.filteredList.filter(item => item.clientId == clientId);
      //console.log("filterByClientId: " + clientId + "   post size: " + this.filteredList.length);
    },    
    async filterBySurveyIds(surveyList){
      //console.log("filterBySurveyIds: " + surveyList.length + "   original size: " + this.filteredList.length);
      if (typeof surveyList != "undefined" && surveyList.length == 0){
        return;
      }
      this.filteredList = this.filteredList.filter(uniqueCodeInput => surveyList.includes(Number(uniqueCodeInput.surveyId)));
      //console.log("filterBySurveyIds: " + surveyList.length + "   post size: " + this.filteredList.length);
    },    
    async filterByStatus() {
      //console.log("filterByStatus: " + this.filterByStatusValue + "   original size: " + this.filteredList.length);
      if (this.filterByStatusValue != "" && !this.isFilterListEmpty){
        this.filteredList = this.filteredList.filter(item => item.status == this.filterByStatusValue);
      }
    },
    async filterByCreatedDateRange() {
      //console.log("filterByCreatedDateRange : " + this.filterByCreatedDate + " Filter List size: " + this.filteredList.length);
      if (this.filterByCreatedDate && !this.isFilterListEmpty){
        let vm = this;
        this.filteredList = this.filteredList.filter(item => {
          let dateCreated = moment(item.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("YYYY-MM-DD");
          let filterByCreatedStartDate = moment(vm.filterByCreatedStartDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          let filterByCreatedEndDate = moment(vm.filterByCreatedEndDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          return dateCreated >= filterByCreatedStartDate && dateCreated <= filterByCreatedEndDate;
        });
      }
    },
    async filterByCompletedDateRange() {
      //console.log("filterByCompletedDateRange: " + this.filterByCompletedDate + " Filter List size: " + this.filteredList.length);
      if (this.filterByCompletedDate && !this.isFilterListEmpty){
        let vm = this;
        this.filteredList = this.filteredList.filter(item => {
          let dateCompleted = moment(item.dateCompleted, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("YYYY-MM-DD");
          let filterByCompletedStartDate = moment(vm.filterByCompletedStartDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          let filterByCompletedEndDate = moment(vm.filterByCompletedEndDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          return dateCompleted >= filterByCompletedStartDate && dateCompleted <= filterByCompletedEndDate;
        });
      }
    }

  },
  watch: {},
  mounted() {},
  computed: {
    isFilterListEmpty: function(){
      return this.filteredList.length == 0;
    }
  }
};
</script>
